// extracted by mini-css-extract-plugin
export var body = "_bu-0";
export var sectionHeader = "_bu-4";
export var shortcutColumns = "_bu-2";
export var shortcutList = "_bu-1";
export var shortcutSection = "_bu-3";